import React, { Fragment, memo } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';

import Drawer from 'components/UI/Antd/Drawer/Drawer';
import Button from 'components/UI/Antd/Button/Button';

import WizardSignUp from '../MembershipsWizard/WizardSignUp';
import WizardSignIn from '../MembershipsWizard/WizardSignIn';
import WizardGuest from '../MembershipsWizard/WizardGuest';

import {
  WizardHeader,
  StepHeader,
  StepHeadline
} from '../MembershipsWizard/MembershipsWizard.style.js';

import {
  SIGN_UP_AUTH,
  SIGN_IN_AUTH,
  GUEST_RESERVATION
} from '../MembershipsWizard/MembershipsWizard';

const WizardDrawer = ({
  auth,
  visible,
  handleBack,
  handleClose,
  handleOpenSuccess,
  backButtonText,
  values,
  date,
  setAuth,
  calculatedPrice,
  selectedMarina
}) => {
  return (
    <Drawer
      className='wizard-drawer'
      placement='right'
      title={
        <WizardHeader>
          <StepHeader onClick={handleBack}>
            <Button className='drawer-back-button'>
              <MdKeyboardArrowLeft size={24} color='#ffffff' />
            </Button>
          </StepHeader>
        </WizardHeader>
      }
      closable={false}
      onClose={handleClose}
      visible={visible}
      maskStyle={{ backgroundColor: 'transparent' }}
      width='426px'
      zIndex={10001}
    >
      <Fragment>
        {auth === SIGN_UP_AUTH && (
          <WizardSignUp
            flow='RESERVATION'
            values={values}
            onSignInAuth={() => setAuth(SIGN_IN_AUTH)}
            date={date}
            onCloseDrawer={handleClose}
            onGuestFlow={() => setAuth(GUEST_RESERVATION)}
            selectedMarina={selectedMarina}
          />
        )}
        {auth === SIGN_IN_AUTH && (
          <WizardSignIn
            flow='RESERVATION'
            onSignUpAuth={() => setAuth(SIGN_UP_AUTH)}
            date={date}
            onCloseDrawer={handleClose}
            onGuestFlow={() => setAuth(GUEST_RESERVATION)}
            selectedMarina={selectedMarina}
          />
        )}
        {auth === GUEST_RESERVATION && (
          <WizardGuest
            values={values}
            date={date}
            calculatedPrice={calculatedPrice}
            onCloseDrawer={handleClose}
            onSignInAuth={() => setAuth(SIGN_IN_AUTH)}
            onSignUpAuth={() => setAuth(SIGN_UP_AUTH)}
            onOpenSuccess={handleOpenSuccess}
            selectedMarina={selectedMarina}
          />
        )}
      </Fragment>
    </Drawer>
  );
};

export default memo(WizardDrawer);
